<template>
  <div>
    <CRow>
      <CCol xs="12" lg="12">
        <CModal :title="submitType === 'Update' ? $lang.post.crud.edit : $lang.common.general.reason" size="lg"
              :show.sync="largeModal" :no-close-on-backdrop="true" color="primary">
              <CCardBody>
                <CRow>
                  <CCol md="12">
                    <c-textarea v-model="reason" :rows="5" :cols="10" placeholder="Add Reason"></c-textarea>
                  </CCol>
                  <CCol md="6">
                    <div class="form-group">
                      <CButton color="primary" v-c-tooltip="$lang.buttons.general.crud.submit" :disabled="submitted"
                        v-on:click="blockPost(statusId)">
                        Submit
                      </CButton>
                    </div>
                  </CCol>
                </CRow>
              </CCardBody>
              <template #footer style="display: none">
                <CButton @click="darkModal = false" color="danger" style="display: none">Discard</CButton>
                <CButton @click="darkModal = false" color="success" style="display: none">Accept</CButton>
              </template>
            </CModal>
        <CCard>
          <CCardHeader>
            <div class="row">
              <CCol sm="6" class="align-self-center">
                <strong>View Library</strong>
              </CCol>
            </div>
          </CCardHeader>
          <CCardBody>

            <div class="detail-div">
              <CRow>
                <CCol md="12" class="align-self-center">
                  <CRow>
                    <CCol sm="6" md="4" lg="4">
                      <p class="custome-labal">Name</p>
                      <p class="custome-detail">{{ responseData.name }}</p>
                    </CCol>
                    <CCol sm="6" md="4" lg="4">
                      <p class="custome-labal">Description</p>
                      <p class="custome-detail">{{ responseData.description }}</p>
                    </CCol>
                    <CCol sm="6" md="4" lg="4">
                      <p class="custome-labal">Address</p>
                      <p class="custome-detail">{{ responseData.address }}</p>
                    </CCol>
                    <CCol sm="6" md="4" lg="4">
                      <p class="custome-labal">Mobile Number</p>
                      <p class="custome-detail">{{ responseData.mobileNumber }}</p>
                    </CCol>
                    <CCol sm="6" md="4" lg="4">
                      <p class="custome-labal">Email</p>
                      <p class="custome-detail">{{ responseData.email }}</p>
                    </CCol>
                    <CCol sm="6" md="4" lg="4">
                      <p class="custome-labal">City</p>
                      <p class="custome-detail">{{ responseData.city.name }}</p>
                    </CCol>
                    <CCol sm="6" md="4" lg="4">
                      <p class="custome-labal">Country</p>
                      <p class="custome-detail">{{ responseData.country.name }}</p>
                    </CCol>
                    <CCol sm="6" md="4" lg="4">
                      <p class="custome-labal">State</p>
                      <p class="custome-detail">{{ responseData.country.name }}</p>
                    </CCol>
                    <CCol sm="6" md="4" lg="4">
                      <p class="custome-labal">Link</p>
                      <p class="custome-detail">{{ responseData.link }}</p>
                    </CCol>
                    <CCol sm="12" md="12" lg="12">
                      <p class="custome-labal">Genre</p>
                      <p class="custome-detail">{{ genre }}</p>
                    </CCol>
                  </CRow>
                  <CRow v-show="responseData.blockedReason">
                      <CCol sm="12" align="left">
                        <strong>Blocked Reason: </strong> {{ responseData.blockedReason }}
                      </CCol>
                    </CRow>
                    <CRow v-if="!responseData.blockedReason">
                        <CCol sm="12" align="left">
                          <CButton :color="statusColor" v-c-tooltip="statusLabel" v-on:click="beforeBlocked()">
                            {{ statusLabel }}
                          </CButton>
                        </CCol>
                    </CRow>
                </CCol>
              </CRow>
            </div>
          </CCardBody>
        </CCard>
      </CCol>
    </CRow>
  </div>
</template>
<script>
import Vue from "vue";
import VueForm from "vue-form";
import store from "/src/store/store.js";
import {Mixin} from "/src/mixins/index.js";
import options from "/src/validations/validations.js";
import {ServerTable} from "vue-tables-2";
import VueSweetalert2 from "vue-sweetalert2";
import VueTelInput from "vue-tel-input-fix";
import "vue-tel-input-fix/dist/vue-tel-input.css";

Vue.use(VueTelInput);
Vue.use(VueSweetalert2);
Vue.use(ServerTable, {}, false);
Vue.use(VueForm, options);
export default {
  name: "StaffEdit",
  mixins: [Mixin],
  data() {
    return {
      submitType: "",
      responseData:{},
      largeModal: false,
      genre:"",
      reason:"",
      submitted: false,
      statusId: "",
      statusLabel: "Block",
      statusColor: "danger",
      statusOption:[],
      status:""
    };
  },
  mounted() {
    let self = this;
    self.statusOption.push(
      { value: "1", label: "Active" },
      { value: "0", label: "InActive" },
      { value: "2", label: "Block" },
      { value: "3", label: "Closed" },
      { value: "4", label: "Draft" }
    );
    self.dismissCountDown = 0;
    localStorage.setItem("showAlert", "");
    self.dismissCountDown = 0;
    const id = this.$route.params.id;
    self.dismissCountDown = 0;
    self.editId = id;
    axios
        .get('library/'+self.editId)
        .then((response) => {
          self.responseData = response.data.data;
          self.status=response.data.data.status;
          self.statusId=response.data.data.status;
          self.reason=response.data.data.blockedReason;
          self.genre = response.data.data.genre.map(item => item.title).join(', ');
          store.commit("showLoader", false); // Loader Off
        })
        .catch(function (error) {
          store.commit("showLoader", false); // Loader Off
        });
  },
  watch: {
    $route: {
      immediate: true,
      handler(route) {
        if (route.query && route.query.page) {
          this.activePage = Number(route.query.page);
        }
      },
    },
    avatar: {
      handler: function () {
        this.saved = false;
      },
      deep: true,
    },
  },
  methods: {
    beforeBlocked() {
      let self = this;
      self.reason = "";
      if (self.status == 0) {
        this.largeModal = true;
      } else {
        this.blockPost(self.statusId);
      }
    },
    blockPost(statusId) {
      let self = this;
      self.submitted = true; //Enable Button
      if (self.status == 1) {
        if (self.reason === "") {
          self.submitted = false; //Enable Button
          return false;
        }
        this.$swal({
          title: this.$lang.common.status.want_to_block,
          type: "warning",
          showCancelButton: true,
          confirmButtonColor: "#e55353",
          confirmButtonText: this.$lang.common.status.yes_block,
          cancelButtonText: this.$lang.common.status.cancel,
        }).then((result) => {
          if (result.value) {
            const id = this.$route.params.id;
            setTimeout(() => {
              let self = this;
              const postData = {
                status: statusId,
                reason: self.reason,
              };
              let status, button;
              if (self.statusId === "1") {
                self.statusId = "2";
                self.statusColor = "danger";
                status = this.getStatusLabel(1);
                button = "Block";
              } else {
                self.statusId = "1";
                self.statusColor = "success";
                status = "Blocked";
                button = this.getStatusLabel(1);
              }

              axios
                .post('library/status/'+id, postData)
                .then(function (response) {
                  if (response.data.code === 200) {
                    self.isStatus = status;
                    self.statusLabel = button;
                    self.largeModal = false;
                    self.submitted = false; //Enable Button
                    self.$router.go();
                  } else {
                    self.err_msg = response.data.message;
                    self.dismissCountDown = 10;
                  }
                })
                .catch(function (error) {
                  self.submitted = false; //Enable Button
                });
            }, 500);
          }
        });
      } else {
        const id = this.$route.params.id;
        let self = this;
        const postData = {
          status: 2,
          reason: self.reason,
        };
        let status, button;
        if (self.statusId == "1") {
          self.statusId = "2";
          self.statusColor = "danger";
          status = this.getStatusLabel(1);
          button = "Block";
        } else {
          self.statusId = "1";
          self.statusColor = "success";
          status = "Blocked";
          button = this.getStatusLabel(1);
        }
        axios
          .post('library/status/'+id, postData)
          .then(function (response) {
            if (response.data.code === 200) {
              self.isStatus = status;
              self.statusLabel = button;
              self.largeModal = false;
              self.submitted = false; //Enable Button
              self.$router.go();
            } else {
              self.err_msg = response.data.message;
              self.dismissCountDown = 10;
            }
          })
          .catch(function (error) {
            self.submitted = false; //Enable Button
          });
      }
    },
    getStatusLabel(getStatus) {
      let valObj = " ";
      valObj = this.statusOption.filter(function (elem) {
        if (elem.value == getStatus) return elem.value;
      });
      if (valObj.length > 0) return valObj[0].label;
    },
  },
};
</script>
<style>
#app {
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  text-align: center;
  color: #2c3e50;
  margin-top: 60px;
}
</style>
